import React, { useState, useRef, useEffect, useContext } from "react";
import { baseUrl } from '../../config.js'
import { NavLink, Outlet, useLocation } from 'react-router-dom';

import './NavBarCuenta.css';

import useToken from "../../useToken.js";

// Iconos SVG personalizados
const IconPersonas = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M20 8V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23 11H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const IconAlmacenes = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const IconPublicaciones = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2 14L6 10L10 14L22 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="7" cy="8" r="1.5" fill="currentColor"/>
    </svg>
);

const NavBar = ({})=>{

    const {token} = useToken();
    const location = useLocation();
    const [subMenu, setSubMenu] = useState({});

    useEffect(()=>{
        console.log(location.pathname.split('/'))
    }, [location])

    return(
        <div className="dashCuenta">
            <nav className="sidebar-modern">
                <div className="sidebar-content">
                    <div className="sidebar-header">
                        <h2>Gestión</h2>
                    </div>
                    <div className="sidebar-menu">
                        <NavLink to='/host/gestion/personas' className={({isActive}) => isActive || !location.pathname.split("/")[3] ? 'active' : ''}>
                            <div className="iconoCuenta">
                                <IconPersonas />
                            </div>
                            <div>Personas</div>
                        </NavLink>
                        <NavLink data-tour="nav-almacenes" to='/host/gestion/almacenes'>
                            <div className="iconoCuenta">
                                <IconAlmacenes />
                            </div>
                            <div>Almacenes</div>
                        </NavLink>
                        <NavLink data-tour="nav-publicaciones" to='/host/gestion/publicaciones'>
                            <div className="iconoCuenta">
                                <IconPublicaciones />
                            </div>
                            <div>Publicaciones</div>
                        </NavLink>
                    </div>
                </div>
            </nav>
            <Outlet/>
        </div>
    )
}

export default NavBar;